import { Component, Input, OnInit } from '@angular/core';

import {
  IParametersCommission,
  IProduct,
} from './../../../../models/commission';

@Component({
  selector: 'app-comissao-visualizacao',
  templateUrl: './comissao-visualizacao.component.html',
  styleUrls: ['./comissao-visualizacao.component.scss']
})
export class ComissaoVisualizacaoComponent implements OnInit {
  @Input() product!: IProduct;
  @Input() parameters!: IParametersCommission;

  bankName: string = '';
  companyName: string = '';
  productName: string = '';
  isFixedCommissionType: boolean = false;
  commissionTypeName: string = '';

  constructor() { }

  ngOnInit(): void {
    this.getNamesByProduct();
    this.isFixedCommissionType = this.product.CommissionType === 1;
    this.commissionTypeName = this.isFixedCommissionType ? 'Fixa' : 'Variável';
  }

  getNamesByProduct(): void {
    this.bankName = this.getBankName;
    this.companyName = this.getCompanyName;
    this.productName = this.getProductName;
  }

  get getBankName(): string {
    return this.parameters.Banks.find(
      (bank) => bank.BankId === this.product.BankId
    )?.Name as string;
  }

  get getCompanyName(): string {
    return (this.companyName = this.parameters.Enterprises.find(
      (company) => company.CompanyId === this.product.CompanyId
    )?.Name as string);
  }

  get getProductName(): string {
    return this.parameters.ProductsName.find(
      (product) => product.ProductId === this.product.ProductId
    )?.Name as string;
  }
}
